import { createContext } from "react";

export const BatchResults = createContext([]);
